<template>
  <EuiContainer>
    <EuiGrid class="mx-0 mt-2">
      <EuiBlock class="w-1/2" title="Mail - Recherche de log">
        <form @submit.prevent="mixinsLogsLaunchSearch">
          <EuiGridRow class="mt-3">
            <EuiTextField
                v-model="from"
                type="date"
                label="A partir du"
                adaptSize
                class="mr-3"
            />
            <EuiTextField
                v-model="to"
                type="date"
                label="jusqu'au"
                adaptSize
                class="ml-3"
            />
          </EuiGridRow>
          <EuiGridRow class="mt-3" >
            <EuiTextField
                v-model="query"
                label="mail recherché"
                type="text"
                adaptSize
                placeholder="Chaine de caractère"/>
          </EuiGridRow>
          <EuiGridRow justify="end" class="my-5" >
            <EuiButton
                color="primary"
                variant="text"
                type="button"
                @click.prevent="resetField">
              Réinitialiser
            </EuiButton>
            <EuiButton
                :disabled="isDisabledButtonSearch"
                color="primary"
                variant="raised"
                type="submit">
              Rechercher
              <EuiTooltip v-show="formHasError()" :content="mixinsLogsGetErrorMessage" placement="top">
                <template slot="anchor">
                  <EuiIcon class="eui-u-ml-4" name="help" size="medium"/>
                </template>
              </EuiTooltip>
            </EuiButton>
          </EuiGridRow>
        </form>
      </EuiBlock>
      <EuiGridRow v-if="getterIsLaunch " class="mt-4">
        <resultMails />
      </EuiGridRow>
    </EuiGrid>
  </EuiContainer>
</template>

<script>
import Vue from 'vue';
import resultMails from '@/components/mails/resultMails.vue';
import logs from '@/mixins/logs';

export default {
  name: 'pages.mails.search',
  mixins: [logs],
  components: {
    resultMails,
  },
  mounted() {
    this.resetField();
    if (this.$route.params.emailToSearch !== undefined) {
      this.query = this.$route.params.emailToSearch;
      this.mixinsLogsLaunchSearch();
      this.storeStartSearch();
    }
  },
  data() {
    return {
      to: '',
      from: '',
      query: '',
    };
  },
  computed: {
    isDisabledButtonSearch() {
      if (this.from > this.to || this.query === '') {
        return true;
      }
      return false;
    },
  },
  watch: {
    to() {
      if (this.getterIsLaunch && this.$route.params.emailToSearch === undefined) {
        this.mixinsLogsClearResult();
      }
    },
    from() {
      if (this.getterIsLaunch && this.$route.params.emailToSearch === undefined) {
        this.mixinsLogsClearResult();
      }
    },
    query() {
      if (this.getterIsLaunch && this.$route.params.emailToSearch === undefined) {
        this.mixinsLogsClearResult();
      }
    },
  },
  methods: {
    parameters() {
      return {
        query: `"${this.query}"`,
        from: `${this.from} 00:00:00.000`,
        to: `${this.to} 23:59:59.999`,
        offset: this.offset,
        limit: this.limit,
        filter: `streams:${Vue.prototype.$runtimeConfig.VUE_APP_GRAYLOG_STREAM_ID_MAIL}`,
        sort: 'timestamp:desc',
        decorate: true,
      };
    },
    resetField() {
      this.storeResetSearch();
      this.to = this.mixinsLogsInitDate();
      this.from = this.mixinsLogsInitDate(1);
      this.offet = 0;
      this.query = '';
    },
    formHasError() {
      if (this.query === '') {
        return false;
      }
      return this.from > this.to;
    },
  },
};
</script>
